<template>
  <div class="dqyxfx-warp">
    <div class="left-content ">
      <div class="wrap">
        <device-list-new @bindClassItem="bindClassItem"></device-list-new>
      </div>
    </div>
    <div class="right-content dn-content-bg" style="width: calc(100% - 440px)" v-if="classItem">
      <equipment-item :datas="datas" :loading="loading"></equipment-item>
    </div>
  </div>
</template>
<script>
import api from '@common/api/index.js'
import * as utils from '@/utils/index.js'
import socket from '@/utils/websocket.js' // 组件
import deviceListNew from '@/components/page/equipment/deviceListNew.vue'
import equipmentItem from '@/components/page/equipment/equipmentItem.vue'
export default {
  components: {
    deviceListNew,
    equipmentItem,
  },
  data () {
    return {
      classItem: null,
      load: true,
      datas: [],
      Treedata: [],
      selectedDate: null,
      selectedMeasure: null,
      meausreItem: null,
      loading: true,
      collectData: window.baseConfig.collectData,
    }
  },
  created () { },
  mounted () { },
  activated () { },
  watch: {},
  destroyed () {
    let vm = this
    vm.socket.close()
  },
  methods: {
    /* item设备列表 enumClass枚举名称 selectedMeasure组织结构计量点  */
    async bindClassItem (item, enumClass, selectedMeasure) {
      let vm = this
      vm.loading = true
      vm.meausreItem = item
      /* 当计量点个数为0时就没必要往下执行了 */
      if (!item || item.measures.length == 0) {
        vm.$message.warning('暂无计量点信息')
        vm.datas = []
        vm.loading = false
        return false
      }
      vm.classItem = item
      let data = []
      //获取测量点相
      let res1 = await vm.$api.measure.listPhotosOfMeasureByPack(
        JSON.stringify(item.measures)
      )
      //获取参数组
      let resMeausre = await vm.$api.measure.getMeasuresProperties(
        JSON.stringify(item.measures)
      )
      for (let i = 0; i < item.measureData.length; i++) {
        let newTitle = item.measureData[i].name
        let imgData =
          'data:image/jpeg;base64,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'
        let tempImg = null
        let resMeausreItems = null
        if (res1.data) {
          tempImg = res1.data.find(
            (tempData) => tempData.measureId === item.measureData[i].id
          )
          if (tempImg) {
            imgData = 'data:image/png;base64,' + tempImg.data
          }
        }
        data.push({
          id: item.measureData[i].id,
          title: item.measureData[i].name,
          newTitle: newTitle,
          titleColor: '-',
          imageUrl: imgData,
          data: [
            {
              name: '运行状态',
              value: '-', //-  灰色  0 红色  1 绿色
            },
          ],
          equipmentglDataItem: [], //数据项
          equipmentglStatus: [], //开关判断数据项
          equipmentglStatusJudge: [], //开关判断数据项值
        })
        if (resMeausre.data) {
          resMeausreItems = resMeausre.data.find(
            (tempData) => tempData.id === item.measureData[i].id //
          )
          if (resMeausreItems) {
            for (let k = 0; k < resMeausreItems.propertyGroups.length; k++) {
              for (
                let c = 0;
                c < resMeausreItems.propertyGroups[k].properties.length;
                c++
              ) {
                let ctem = resMeausreItems.propertyGroups[k].properties[c]
                if (ctem.name.indexOf('equipmentglDataItem') > -1) {
                  let value = ctem.value.split('|')
                  value.forEach((obj) => {
                    /* 有多少数据项便加入多少项数据项 */
                    data[i].data.push({
                      name: '',
                      value: '-', //单位
                      unit: '',
                      codeName: obj,
                    })
                    data[i].equipmentglDataItem.push({
                      codeName: obj,
                      pointCode: '',
                      pointNumber: '',
                    })
                  })
                }
                /* 单位 */
                if (ctem.name.indexOf('equipmentglDataItemUnit') > -1) {
                  let value = ctem.value.split('|')
                  value.forEach((obj, j) => {
                    /* 有多少数据项便加入多少项数据项 */
                    data[i].data[j]['unit'] = obj
                  })
                }
                /* 加入数据项*/
                if (ctem.name == 'equipmentglStatus') {
                  let value = ctem.value.split('|')
                  value.forEach((obj) => {
                    data[i].equipmentglStatus.push({
                      codeName: obj,
                      pointCode: '',
                      pointNumber: '',
                      value: '-',
                    })
                  })
                }
                /* 加入比对开关数据 */
                if (ctem.name == 'equipmentglStatusJudge') {
                  let value = ctem.value.split('|')
                  value.forEach((obj) => {
                    data[i].equipmentglStatusJudge.push({
                      value: obj,
                    })
                  })
                }
              }
            }
          }
        }
      }
      vm.loading = false
      vm.datas = data
      let resMeasure = await api.measure.getUniqueMeasuresExpressions(
        JSON.stringify(item.measures)
      )
      // .then((resMeasure) => {
      vm.measureExpressionData = resMeasure.data
      let wsPoints = []
      for (let i = 0; i < resMeasure.data.length; i++) {
        let item = {}
        item.id = resMeasure.data[i].id
        item.points = []
        if (resMeasure.data[i].expressionGroups) {
          for (let j = 0; j < resMeasure.data[i].expressionGroups.length; j++) {
            for (
              let k = 0;
              k < resMeasure.data[i].expressionGroups[j].expression.length;
              k++
            ) {
              const element =
                resMeasure.data[i].expressionGroups[j].expression[k]
              vm.datas.map((wey, w) => {
                wey.data.map((zey, z) => {
                  if (zey.codeName == element.name) {
                    //拿取展示数据项的名称
                    vm.datas[w].data[z].name = element.displayName
                  }
                })
                /* 数据项 */
                wey.equipmentglDataItem.map((zey, z) => {
                  if (zey.codeName == element.name) {
                    vm.datas[w].equipmentglDataItem[z].pointCode =
                      element.pointCode
                    vm.datas[w].equipmentglDataItem[z].pointNumber =
                      element.pointNumber
                  }
                })
                /* 开关比对数据项 */
                wey.equipmentglStatus.map((zey, z) => {
                  if (zey.codeName == element.name) {
                    vm.datas[w].equipmentglStatus[z].pointCode =
                      element.pointCode
                    vm.datas[w].equipmentglStatus[z].pointNumber =
                      element.pointNumber
                  }
                })
              })
              vm.datas.map((wey, w) => {
                if (
                  element.pointCode == '601' ||
                  wey.equipmentglDataItem.findIndex(
                    (c) =>
                      c.pointCode == element.pointCode &&
                      ((c) => c.pointNumber == element.pointNumber)
                  ) > -1 ||
                  wey.equipmentglStatus.findIndex(
                    (c) =>
                      c.pointCode == element.pointCode &&
                      ((c) => c.pointNumber == element.pointNumber)
                  ) > -1
                ) {
                  item.points.push({
                    code: element.pointCode,
                    number: element.pointNumber,
                  })
                }
              })
            }
          }
        }
        let hash = {}
        /*  item.point 去重,防止增加多个相同的code*/
        const data2 = item.points.reduce((preVal, curVal) => {
          hash[curVal.code]
            ? ''
            : (hash[curVal.code] = true && preVal.push(curVal))
          return preVal
        }, [])
        item.points = data2
        if (item.points.length > 0) {
          wsPoints.push(item)
        }
      }

      vm.wsPoints = wsPoints
      vm.allotMeasuringRealtimeNotifyServer()
    },

    allotMeasuringRealtimeNotifyServer () {
      let vm = this
      api.measuringServer.allotMeasuringRealtimeNotifyServer().then((res) => {
        let serverData = res.data
        vm.socket = new socket({
          //网址（端口是我下面的服务器的端口）
          url: window.baseConfig.wsAgreement + "://" + + serverData.ip + ':' + serverData.port + "/" + serverData.path,
        })
        vm.socket.onopen((event) => {
          vm.socket.send({
            methodCode: '101',
            key: serverData.key,
          })
        })
        //接收信息
        vm.socket.onmessage((data) => {
          vm.webSockMsg(JSON.parse(data))
        })
      })
    },
    webSockMsg (obj) {
      let vm = this
      if (obj.methodCode == '102') {
        vm.socket.send({
          methodCode: '103',
          measures: vm.wsPoints,
        })
      } else if (obj.methodCode == '105') {
        for (let i = 0; i < obj.data.length; i++) {
          let index = vm.datas.findIndex((c) => c.id == obj.data[i].measureId)
          if (index > -1) {
            let state = '-',
              power = '-',
              vollage = 0
            let newState = '-'

            for (let j = 0; j < obj.data[i].data.length; j++) {
              if (obj.data[i].data[j].pointCode == '601') {
                state = state == 0 ? state : obj.data[i].data[j].value
              }
              /* 如果数据项的code与ws的code相同时，讲数据放进来 */
              //拿到展示数据值
              vm.datas[index].equipmentglDataItem.forEach((ktem, k) => {
                if (ktem.pointCode == obj.data[i].data[j].pointCode) {
                  vm.datas[index].data[k + 1].value =
                    obj.data[i].data[j].value == '-'
                      ? vm.datas[index].data[1].value
                      : parseFloat(obj.data[i].data[j].value).toFixed(2)
                }
              })
              /* 放置开关数据项数据 */
              vm.datas[index].equipmentglStatus.forEach((ktem, k) => {
                if (ktem.pointCode == obj.data[i].data[j].pointCode) {
                  vm.datas[index].equipmentglStatus[k].value =
                    obj.data[i].data[j].value == '-'
                      ? vm.datas[index].data[1].value
                      : parseFloat(obj.data[i].data[j].value).toFixed(2)
                }
              })
            }
            /* 如果开关数据项的数据大于比对数据时 */
            vm.datas[index].equipmentglStatus.forEach((ftem, f) => {
              vm.datas[index].equipmentglStatusJudge.map((ccj) => {
                if (parseFloat(ftem.value) >= parseFloat(ccj.value)) {
                  vollage = 1
                }
              })
            })
            if (state == '-') {
              /* 优先考虑状态量，当状态量不存在的时候考虑 开关量判断动态数据项 */
              newState = vollage
            } else {
              newState = state
            }
            vm.datas[index].data[0].value =
              newState == '-' ? vm.datas[index].data[0].value : newState
            vm.datas[index].titleColor = vm.datas[index].data[0].value
          }
        }
      } else {
      }
    },
  },
}
</script>
<style scoped lang="scss">
.zt {
  color: #000;
}

.dqyxfx-warp {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 14px;
  box-sizing: border-box;
  color: #000;
  font-family: Microsoft YaHei;
  font-weight: 600;
}
.left-content {
  width: 440px;
  min-width: 200px;
  //   margin-right: 14px;
  .wrap {
    width: 100%;
    height: 100%;
  }
}
.right-content {
  height: 100%;
  overflow: auto;
}
</style>